import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { MakeOfferMutationRequest, MakeOfferMutationResponse, MakeOfferQueryParams } from "../../types/MakeOffer";

/**
     * @link /api/purchase-tenders/private/v1/offer
     */
export async function makeOffer (data: MakeOfferMutationRequest, params: MakeOfferQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<MakeOfferMutationResponse>["data"]> {
    const { data: resData } = await client<MakeOfferMutationResponse, MakeOfferMutationRequest>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/offer`,
        params,
        data,
        ...options
    });
    
    return resData;
};